/** @module csi/widget/RefSelect */
define([
	"dojo/_base/declare",
	"mobx",
	"csi",
	"csi/state/rootStore",
	"./FilteringSelect",
	"./RefSelectMixin",
], function(declare, {runInAction}, csi, {localStore}, FilteringSelect, RefSelectMixin) {

	// FilteringSelect that is enhanced with "Go to Dialog"

	return declare([FilteringSelect, RefSelectMixin], {
		/**
		 * Return selected urls in widget.
		 * @return {string[]}
		 */
		getWidgetSelections: function() {
			return [this.get("value") || csi.EMPTY_URL];
		},

		_onBlur: function() {
			if (this.hasPlaceholder && !this.focusNode.value && (this._lastValueReported !== "centric:")) {
				if (localStore.dismissConfirmationDialogOnClearSelection) {
					this.set("value", csi.EMPTY_URL);
				} else {
					this.showConfirmOnClearSelectionDialog(
						this._csiResetValue,
						this._lastDisplayedValue,
						(shouldDismiss) => (
							runInAction(() => {
								localStore.dismissConfirmationDialogOnClearSelection = shouldDismiss;
							})
						),
						(value) => this.set("value", value)
					);
				}
			}
			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Return true if target is Go to Dialog
		 */
		isGoToDialogTarget(target) {
			const {dropDown, store} = this;
			const item = dropDown.items[target.getAttribute("item")];
			const value = store.getIdentity(item);
			return value === csi.DIALOG_URL;
		},

		/**
		 * Apply selections from the "Go to Dialog" view to the widget
		 * @param {string[]} value
		 */
		setWidgetSelections(value) {
			this.set("value", value[0] || csi.EMPTY_URL, true);
		}
	});
});